/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';

import { IObrienPerformanceNumbersData } from './obrien-performance-numbers.data';
import { performanceAnimation1, performanceAnimation2, performanceAnimation3, performanceAnimation4, performanceAnimation5, IObrienPerformanceNumbersProps } from './obrien-performance-numbers.props.autogenerated';

export interface IObrienPerformanceNumbersViewProps extends IObrienPerformanceNumbersProps<IObrienPerformanceNumbersData> {

    performanceTitle1?: React.ReactNode;
    performanceTitle2?: React.ReactNode;
    performanceTitle3?: React.ReactNode;
    performanceTitle4?: React.ReactNode;
    performanceTitle5?: React.ReactNode;

    performanceAnimationOne?: performanceAnimation1;
    performanceAnimationTwo?: performanceAnimation2;
    performanceAnimationThree?: performanceAnimation3;
    performanceAnimationFour?: performanceAnimation4;
    performanceAnimationFive?: performanceAnimation5;


}

/**
 *
 * ObrienPerformanceNumbers component
 * @extends {React.PureComponent<IObrienPerformanceNumbersProps<IObrienPerformanceNumbersData>>}
 */
class ObrienPerformanceNumbers extends React.PureComponent<IObrienPerformanceNumbersProps<IObrienPerformanceNumbersData>> {
    public render(): JSX.Element | null {

        const { config } = this.props;

        const { 
            performanceTitle1,
            performanceTitle2,
            performanceTitle3,
            performanceTitle4,
            performanceTitle5
            
        } = this.props.config;


        const PerformanceTitle1 = performanceTitle1 && (
            <Msdyn365.Text
              tag={performanceTitle1.tag || 'h3'}
              text={performanceTitle1.text}
              editProps={{onEdit: this.handleTextChange1, requestContext:this.props.context.request}}
            />
        );
        const PerformanceTitle2 = performanceTitle2 && (
            <Msdyn365.Text
              tag={performanceTitle2.tag || 'h3'}
              text={performanceTitle2.text}
              editProps={{onEdit: this.handleTextChange2, requestContext:this.props.context.request}}
            />
        );
        const PerformanceTitle3 = performanceTitle3 && (
            <Msdyn365.Text
              tag={performanceTitle3.tag || 'h3'}
              text={performanceTitle3.text}
              editProps={{onEdit: this.handleTextChange3, requestContext:this.props.context.request}}
            />
        );
        const PerformanceTitle4 = performanceTitle4 && (
            <Msdyn365.Text
              tag={performanceTitle4.tag || 'h3'}
              text={performanceTitle4.text}
              editProps={{onEdit: this.handleTextChange4, requestContext:this.props.context.request}}
            />
        );
        const PerformanceTitle5 = performanceTitle5 && (
            <Msdyn365.Text
              tag={performanceTitle5.tag || 'h3'}
              text={performanceTitle5.text}
              editProps={{onEdit: this.handleTextChange5, requestContext:this.props.context.request}}
            />
        );

        const performanceViewProps = {
            ...this.props,
            performanceTitle1: PerformanceTitle1,
            performanceTitle2: PerformanceTitle2,
            performanceTitle3: PerformanceTitle3,
            performanceTitle4: PerformanceTitle4,
            performanceTitle5: PerformanceTitle5,
            performanceAnimationOne: config.performanceAnimation1,
            performanceAnimationTwo: config.performanceAnimation2,
            performanceAnimationThree: config.performanceAnimation3,
            performanceAnimationFour: config.performanceAnimation4,
            performanceAnimationFive: config.performanceAnimation5,
        }


        return this.props.renderView(performanceViewProps) as React.ReactElement;
    }
    public handleTextChange1 = (event: Msdyn365.ContentEditableEvent) => this.props.config.performanceTitle1!.text = event.target.value;
    public handleTextChange2 = (event: Msdyn365.ContentEditableEvent) => this.props.config.performanceTitle2!.text = event.target.value;
    public handleTextChange3 = (event: Msdyn365.ContentEditableEvent) => this.props.config.performanceTitle3!.text = event.target.value;
    public handleTextChange4 = (event: Msdyn365.ContentEditableEvent) => this.props.config.performanceTitle4!.text = event.target.value;
    public handleTextChange5 = (event: Msdyn365.ContentEditableEvent) => this.props.config.performanceTitle5!.text = event.target.value;
   
}

export default ObrienPerformanceNumbers;
